import { ProjectType } from '@lopo-tech/lopo-api'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { ProjectDetailPage } from 'src/pages/project_detail'

const InfrastructureProjectDetailPage: React.FC<RouteComponentProps> = (props) => (
  <ProjectDetailPage {...props} projectType={ProjectType.InfrastructureProject} />
)

export default InfrastructureProjectDetailPage
